$('.video-image').click(function () {
  $('body').addClass('mm-open');
  var video_url = $(this).parent().attr('data-video');
  document.querySelector(
    '.video-content'
  ).innerHTML = `<video playsinline="playsinline" autoplay="autoplay" loop="loop" controls="controls" preload="metadata"><source src="${video_url}" type="video/mp4"></video>`;
});
$('.btn-play').click(function () {
  $('body').addClass('mm-open');
  var video_url = $(this).parents('.video-wrapper').attr('data-video');
  document.querySelector(
    '.video-content'
  ).innerHTML = `<video playsinline="playsinline" autoplay="autoplay" loop="loop" controls="controls" preload="metadata"><source src="${video_url}" type="video/mp4"></video>`;
});
document.querySelector('.close-btn').addEventListener('click', function () {
  document.querySelector('body').classList.remove('mm-open');
  document.querySelector('.video-content').innerHTML = '';
  $('body').removeClass('image-popup');
});
document.querySelector('.popup_bg').addEventListener('click', function () {
  document.querySelector('body').classList.remove('mm-open');
  document.querySelector('.video-content').innerHTML = '';
  $('body').removeClass('image-popup');
});
$('.testimonial-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  dots: true,
  infinite: true,
  responsive: [
    {
      breakpoint: 950,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        centerMode: true,
      },
    },
  ],
});
$('.compare-list-btn').click(function () {
  $('.compare-list-btn').removeClass('active');
  $('.compare-table').removeClass('active');
  $(this).addClass('active');
  if ($(this).hasClass('second-compare-btn')) {
    $('.second-table').addClass('active');
  }
  if ($(this).hasClass('first-compare-btn')) {
    $('.first-table').addClass('active');
  }
});

$('.content-custom_featured_product .quantity__input').change(function () {
  var total_qty = 0;
  var item_qty = $(this).val();

  $(this).parents('.item-variant_item').attr('data-qty', item_qty);
  $('.item-variant_item').each(function () {
    total_qty = total_qty + parseInt($(this).attr('data-qty'));
  });
  $('.discount_item').removeClass('active');
  if (total_qty == 2) {
    var discount_value = $('.discount_item:nth-child(1)').attr('data-value');
    $('.discount_item:first-child').addClass('active');
  }
  if (total_qty > 2) {
    var discount_value = $('.discount_item:nth-child(2)').attr('data-value');
    $('.discount_item:nth-child(2)').addClass('active');
  }
  /* if(total_qty > 2){
    var discount_value = $('.discount_item:nth-child(3)').attr('data-value');
    
    $('.discount_item:nth-child(3)').addClass('active');
  } */
  var total_price = 0;
  $('.item-variant_item').each(function () {
    var item_qty = $(this).attr('data-qty');
    var item_real_price = $(this).attr('data-price');
    var real_price =
      '$' + ((item_real_price * (100 - discount_value)) / 10000).toFixed(2);
    var original_price = '$' + item_real_price / 100;
    if (real_price != '$NaN') {
      $(this).find('.item-variant_discount_price').text(real_price);
      $(this).find('.item-variant_original_price').text(original_price);
      total_price =
        total_price +
        (item_qty * item_real_price * (100 - discount_value)) / 10000;
    } else {
      $(this).find('.item-variant_discount_price').text(original_price);
      $(this).find('.item-variant_original_price').text('');
    }
  });
  if (total_price == '0') {
    $('.total-price').text('');
  } else {
    $('.total-price').text('$' + total_price.toFixed(2));
  }
});
var total_qty = 0;

$('.cart-btn').click(function (e) {
  e.preventDefault();

  $('.item-variant_item').each(function () {
    total_qty = total_qty + parseInt($(this).attr('data-qty'));
  });
  if (total_qty == 0) {
    alert('please add items');
  } else {
    let dataType = [];
    $('.item-variant_item').each(function () {
      if ($(this).attr('data-id') != '') {
        let d = document.querySelector('input[name="selling_plan"]');
        console.log(d.value);
        var data = {};
        data['id'] = $(this).attr('data-id');
        data['quantity'] = $(this).attr('data-qty');
        data['selling_plan'] = d.value;

        dataType.push(data);
      }
    });
    const newData = {
      items: dataType,
    };
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: newData,
      dataType: 'application/json',
    });
    setTimeout(function () {
      $.ajax({
        url: '/?section_id=cart-drawer',
        type: 'GET',
        dataType: 'html',
        success: function (carthtml) {
          window.location.href = '/cart';
          // $('cart-drawer').html($(carthtml).find('cart-drawer').html());
          // $('body').addClass('overflow-hidden');
          // if($('cart-drawer').hasClass('is-empty')) {
          //   $('cart-drawer').removeClass('is-empty');
          // }
          // $('cart-drawer').addClass('animate active');
        },
      });
    }, 500);
  }
});
// $('body').on('click', '.cart-drawer__overlay', function(e) {
//   console.log('test');
//   $('.drawer__close').click();
// });
// Shopify.addToCart = function(items) {
//     fetch(window.Shopify.routes.root + 'cart/add.js', {
//   method: 'POST',
//   headers: {
//     'Content-Type': 'application/json'
//   },
//   body: JSON.stringify(items)
//   })
//   .then(response => {
//     $('cart-drawer').removeClass('is-empty');
//     return response.json();
//   }).then((state) => {
//     console.log("Current State: " + state)
//   })
//   .catch((error) => {
//     console.error('Error:', error);
//   });
// };

$('.ingredient_popup_btn').click(function () {
  $('body').addClass('mm-open image-popup');
  var image_url = $(this).attr('data-url');
  document.querySelector(
    '.video-content'
  ).innerHTML = `<img src="${image_url}">`;
});
$('.item-cart_btn').click(function () {
  $(this).addClass('hidden');
  $(this).parent().find('.quantity__button:last-child').click();
});

$('.second-variant_item .quantity__input').change(function () {
  var item_qty = $(this).val();
  $(this).parents('.second-variant_item').attr('data-qty', item_qty);
  var discount_value = $('.second_discount-info').attr('data-value');
  var total_price = 0;
  var total_qty = 0;
  $('.second-variant_item').each(function () {
    total_qty = total_qty + parseInt($(this).attr('data-qty'));
  });
  console.log(total_qty);
  if (item_qty < 1) {
    $(this)
      .parents('.second-variant_price')
      .find('.item-cart_btn')
      .removeClass('hidden');
  }
  $('.second-variant_item').each(function () {
    var item_qty = $(this).attr('data-qty');
    var item_real_price = $(this).attr('data-price');
    var real_price =
      '$' + ((item_real_price * (100 - discount_value)) / 10000).toFixed(2);
    var original_price = '$' + item_real_price / 100;
    if (total_qty > 0) {
      $(this).find('.item-variant_discount_price').text(real_price);
      $(this).find('.item-variant_original_price').text(original_price);
      total_price =
        total_price +
        (item_qty * item_real_price * (100 - discount_value)) / 10000;
    } else {
      $(this).find('.item-variant_discount_price').text(original_price);
      $(this).find('.item-variant_original_price').text('');
    }
  });
  if (total_price == '0') {
    $('.second-total-price').text('');
  } else {
    $('.second-total-price').text('$' + total_price.toFixed(2));
  }
});

var total_qty = 0;
$('.second-cart-btn').click(function () {
  $('.second-variant_item').each(function () {
    total_qty = total_qty + parseInt($(this).attr('data-qty'));
  });
  if (total_qty == 0) {
    alert('please add items');
  } else {
    let dataType = [];
    $('.second-variant_item').each(function () {
      if ($(this).attr('data-id') != '') {
        var data = {};
        data['id'] = $(this).attr('data-id');
        data['quantity'] = $(this).attr('data-qty');

        dataType.push(data);
      }
    });
    const newData = {
      items: dataType,
    };
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: newData,
      dataType: 'application/json',
    });
    setTimeout(function () {
      $.ajax({
        url: '/?section_id=cart-drawer',
        type: 'GET',
        dataType: 'html',
        success: function (carthtml) {
          window.location.href = '/cart';
          // $('cart-drawer').html($(carthtml).find('cart-drawer').html());
          // $('body').addClass('overflow-hidden');
          // if($('cart-drawer').hasClass('is-empty')) {
          //   $('cart-drawer').removeClass('is-empty');
          // }
          // $('cart-drawer').addClass('animate active');
        },
      });
    }, 500);
  }
});


